import { useSelector } from "react-redux"
import "./WishBox.scss"
import { WishOwner } from "./WishOwner"
import { WishRegs } from "./WishRegs"
import { wishSelectors } from "@/slices/wishSlice"
import { StoreState } from "@/store/StoreState"
import SpinnerContainer from "../load/SpinnerContainer"
import cn from "classnames"
import { getIsAdmin } from "@/services/authService"
import { getBackgroundPosition } from "@/services/clientWishService"
import { settingsSelectors } from "@/slices/settingsSlice"

interface IWishBoxProps {
  wish: IWishDto
  onClick: () => void
  canClick: boolean
}

export const WishBox = ({ wish, onClick, canClick }: IWishBoxProps): JSX.Element => {
  const isLoading = useSelector((state: StoreState) => wishSelectors.isLoading(state, wish.id))

  const adminShowRegistrations = useSelector(settingsSelectors.adminShowRegistrations)
  const hideResults = getIsAdmin() && !adminShowRegistrations

  return (
    <SpinnerContainer showSpinner={isLoading} aboveContent>
      <div className={cn("wish-box", canClick && "wish-box--click")}>
        <div
          className="wish-box__inner"
          style={{
            backgroundImage: wish.imageUrl ? `url("${wish.imageUrl}")` : undefined,
            backgroundColor: wish.imageUrl ? undefined : "lightgray",
            backgroundPosition: getBackgroundPosition(wish.imageFocus),
            backgroundSize: wish.imageFocus === "contain" ? "contain" : "cover",
          }}
          onClick={onClick}
        >
          <div
            className={cn(
              "wish-box__data-container",
              wish.isTitleBackgroundSolid && "wish-box__data-container--bg-solid"
            )}
          >
            {wish.title}
          </div>
        </div>
        {!hideResults && wish.regs >= wish.qty && (
          <div className="wish-box__inner-disabled-overlay"></div>
        )}
        <div className="wish-box__owner">
          <WishOwner wish={wish} />
        </div>
        <div className="wish-box__regs">
          <WishRegs wish={wish} />
        </div>
      </div>
    </SpinnerContainer>
  )
}
